<template>
<div>
   <div class="header2 pc">
          <div class="inner">
            <p>
              <a href="https://www.jxrsrc.com/">
                <img src="@/assets/logo.png" />
              </a>
            </p>
            <p>
              <a href="https://jxrsrc.com/member/login/personal">个人登录</a>
              <a href="https://jxrsrc.com/member/login/company">单位登录</a>
            </p>
          </div>
        </div>
        <div><img :src="banner" alt="" style="width: 100%" /></div>
</div>
</template> 

<script>
// import Vue from "vue";
// import "@/icons/iconfont.js";
import banner from "@/assets/banner6.png";
export default {
  name: "header",
  components: {},
  data() {
    return {
      banner
    };
  },
  created() {
    
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
 .header2 {
  display: flex;
  justify-content: center;
  background-color: #fff;
}
.header2 .inner {
  display: flex;
  justify-content: space-between;
  width: 2500px;
  padding: 15px 0;
  margin: 0 auto;
}
.header2 p {
  display: flex;
}
.header2 p a {
  display: flex;
  height: 40px;
}
.header2 p a img {
  width: auto;
  height: 40px;
}
.header2 p {
  display: flex;
}
.header2 p + p a {
  padding: 0 15px 0 12px;
  background-color: #f2f2f2;
  font-size: 14px;
  color: #333;
  line-height: 40px;
}
.header2 p + p a:nth-child(1):before {
  background: url(http://dlo.jxrsrc.com/zph2022/20220318/img/user_ico01.png)
    no-repeat center;
}
.header2 p + p a:nth-child(2):before {
  background: url(http://dlo.jxrsrc.com/zph2022/20220318/img/user_ico02.png)
    no-repeat center;
}
.header2 p + p a:before {
  content: "";
  display: flex;
  width: 16px;
  height: 16px;
  margin: 12px 8px 12px 0;
}
</style>
